import { recomputeIndexForOptions } from '../actions/pickerOptionsActions';
import { mutator } from 'satcheljs';

mutator(recomputeIndexForOptions, ({ viewState }) => {
    const { options } = viewState;
    let index = 0;

    for (let option of options) {
        for (let leafOption of option.leafOptions) {
            leafOption.index = index;
            index++;
        }

        if (option.parentOptions) {
            for (let parent of option.parentOptions) {
                parent.index = index;
                index++;

                for (let child of parent.children) {
                    child.index = index;
                    index++;
                }
            }
        }
    }
});
